import { OperatingUnit } from '~/api/types';
import { v2Api } from '../v2Api';

const tags = ['operating-unit'] as const;

const operatingUnitApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOperatingUnits: builder.query<OperatingUnit[], object>({
        query: () => 'operating-unit',
        providesTags: tags,
        transformResponse: (response: { data: OperatingUnit[] }) => response.data,
      }),
    }),
  });

export default operatingUnitApi;
